

class LoggerController{
    static get $inject(){ return ['$log'];}
    
    constructor($log){
        this.__log = $log;
    }

    log(){
        //Function.prototype.apply.call( this.__log.log,  this.log, arguments);
    }
    debug(){
        //Function.prototype.apply.call( this.__log.debug,  this.log, arguments);
    }
    error(){
        Function.prototype.apply.call( this.__log.error,  this.log, arguments);
    }
    info(){
       // Function.prototype.apply.call( this.__log.info,  this.log, arguments);
    }
    warn(){
        //Function.prototype.apply.call( this.__log.warn,  this.log, arguments);
    }

}

export { LoggerController };



// WEBPACK FOOTER //
// ./src/core/logger.js